import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SocialComponent } from '../social/social.component';
import { DataService } from '../../core/services/data.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, SocialComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  constructor(private _DataService: DataService) {}

  ngOnInit(): void {
    this.getSettings();
  }

  phoneNumber: any;
  userEmail: any;
  userAddress: any;
  userLocation: any;
  logo: any;
  title: any;
  getSettings(): void {
    this._DataService.getSetting().subscribe({
      next: (res) => {
        // console.log(res.data);
        // phone
        const contactPhone = res.data.find(
          (item: any) => item.option_key === 'CONTACT_PHONE_NUMBER'
        );
        this.phoneNumber = contactPhone?.option_value[0];
        // email
        const contactEmail = res.data.find(
          (item: any) => item.option_key === 'email_address'
        );
        this.userEmail = contactEmail?.option_value[0];
        // address
        const contactaddress = res.data.find(
          (item: any) => item.option_key === 'address'
        );
        this.userAddress = contactaddress?.option_value[0];
        // map
        const contactMap = res.data.find(
          (item: any) => item.option_key === 'company_location_url'
        );
        this.userLocation = contactMap?.option_value[0];
        // logo
        const contactLogo = res.data.find(
          (item: any) => item.option_key === 'logo'
        );
        this.logo = contactLogo?.option_value[0];
        // title site
        const contacttitle = res.data.find(
          (item: any) => item.option_key === 'site_title'
        );
        this.title = contacttitle?.option_value[0];
      },
      error: (err) => {
        // console.log(err);
      },
    });
  }
}
